import script from "./Law.vue?vue&type=script&setup=true&lang=js"
export * from "./Law.vue?vue&type=script&setup=true&lang=js"

import "./Law.vue?vue&type=style&index=0&id=1ef190cc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef190cc"]])

export default __exports__